module.exports = __webpack_public_path__ + "static/media/objects_28.83fbf9e5.svg";